import React, { useEffect } from 'react';

import { EmbedContainer, EmbedIframe } from './styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  redirect_uri: string;
};

const ExecucaoProtocoloEmbed: React.FC<Props> = ({
  isOpen,
  onClose,
  redirect_uri,
}) => {
  useEffect(() => {
    const listener = (event: MessageEvent) => {
      const {
        data: { type },
      } = event;
      if (type === 'closeMedflowApp') {
        onClose();
      }
    };

    if (redirect_uri) {
      window.addEventListener('message', listener, false);
    }

    return () => window.removeEventListener('message', listener);
  }, [onClose, redirect_uri]);

  // Aplica class noscroll no HTML para desabilitar o scroll de página enquanto
  // o embed estiver aberto: ele se ajusta à viewport e quem rola é o iframe,
  // então a barra de fora só ocuparia espaço sem ter para onde rolar
  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];

    if (isOpen) {
      html.classList.add('noscroll');
    } else {
      html.classList.remove('noscroll');
    }

    return () => {
      html.classList.remove('noscroll');
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  // O iframe ocupa uma altura fixa derivada da viewport e rola internamente.
  //
  // Não dá pra dimensioná-lo pelo conteúdo: a SPA de dentro calcula um
  // `margin-bottom` a partir do próprio `window.innerHeight` (ver
  // AutoScrollList) p/ manter o passo corrente no topo. Se a altura do iframe
  // vier do conteúdo, ela vira entrada do cálculo que a produziu -- o
  // margin-bottom cresce a cada medição e a página ganha espaço vazio sem
  // parar.
  return (
    <EmbedContainer>
      <EmbedIframe
        src={redirect_uri}
        title="Execução de Protocolo"
        allow="clipboard-read; clipboard-write"
      />
    </EmbedContainer>
  );
};

export default ExecucaoProtocoloEmbed;
